// src/components/Spinner.tsx
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/Store';

const Loading: React.FC = () => {
  const isLoading = useSelector((state: RootState) => {
    // console.log(state.loader); 
    return state.loader?.isLoading;
  });

  return isLoading ? (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  ) : null;
};

export default Loading;
